// @ts-nocheck
/**
 * 6529.io API
 * This is the API interface description. Brief terminology overview and an authentication example can be found at <a href=\"https://6529.io/about/api\">https://6529.io/about/api</a>.
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { ApiProfileMin } from '../models/ApiProfileMin';
import { HttpFile } from '../http/http';

export class ApiTdhEdition {
    'contract': string;
    'id': number;
    'edition_id': number;
    'balance': number;
    'hodl_rate': number;
    'days_held': number;
    'wallet'?: string | null;
    'consolidation_key'?: string | null;
    'profile'?: ApiProfileMin;

    static readonly discriminator: string | undefined = undefined;

    static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
        {
            "name": "contract",
            "baseName": "contract",
            "type": "string",
            "format": ""
        },
        {
            "name": "id",
            "baseName": "id",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "edition_id",
            "baseName": "edition_id",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "balance",
            "baseName": "balance",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "hodl_rate",
            "baseName": "hodl_rate",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "days_held",
            "baseName": "days_held",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "wallet",
            "baseName": "wallet",
            "type": "string",
            "format": ""
        },
        {
            "name": "consolidation_key",
            "baseName": "consolidation_key",
            "type": "string",
            "format": ""
        },
        {
            "name": "profile",
            "baseName": "profile",
            "type": "ApiProfileMin",
            "format": ""
        }    ];

    static getAttributeTypeMap() {
        return ApiTdhEdition.attributeTypeMap;
    }

    public constructor() {
    }
}

